module.exports = __webpack_public_path__ + "static/media/f-yt.bb9a5ee7.svg";